import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

/** Serviço de validadores personalizados para os controle do formulário. */
export class NDDFormErrorValidatorService {
    /** Valida controle como obrigatório. */
    public static required(trim: boolean): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            if (trim && control.value && control.value.trim) {
                if (control.value.trim().length === 0) {
                    return { required: true };
                }

                return null;
            }

            return Validators.required(control);
        };
    }

    /** Valida e-mail. */
    public static email(control: AbstractControl): ValidationErrors {
        if (!control.value) { return null; }

        const regEx: RegExp =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;

        if (!regEx.test(control.value.trim())) {
            return { email: true };
        }

        return null;
    }

    /** Valida número máximo. */
    public static max(maxNumber: number, localeGroupSymbol: string, localeDecimalSymbol: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            if (!control.value && control.value !== 0) { return null; }

            let value: number;
            if (isNaN(control.value)) {
                value = +control.value.toString().replace(localeGroupSymbol, '').replace(localeDecimalSymbol, '.');
            } else {
                value = +control.value;
            }

            if (value.toString() && !isNaN(value)) {
                if (value > maxNumber) {
                    return { max: { actual: value, max: maxNumber } };
                }
            }

            return null;
        };
    }

    /** Valida número mínimo. */
    public static min(minNumber: number, localeGroupSymbol: string, localeDecimalSymbol: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            if (!control.value && control.value !== 0) { return null; }

            let value: number;
            if (isNaN(control.value)) {
                value = +control.value.toString().replace(localeGroupSymbol, '').replace(localeDecimalSymbol, '.');
            } else {
                value = +control.value;
            }

            if (value.toString() && !isNaN(value)) {
                if (value < minNumber) {
                    return { min: { actual: value, min: minNumber } };
                }
            }

            return null;
        };
    }

    /** Valida número máximo de dígitos decimais. */
    public static maxDecimalDigits(maxDigits: number, localeDecimalSymbol: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            if (!control.value) { return null; }

            const value: number = +control.value.toString().replace(localeDecimalSymbol, '.');

            if (value && !isNaN(value) && !Number.isInteger(value)) {
                const actualDecimalDigits: number = value.toString().split('.')[1].length;

                if (actualDecimalDigits > maxDigits) {
                    return { maxDecimalDigits: { actual: actualDecimalDigits, max: maxDigits } };
                }
            }

            return null;
        };
    }

    /** Valida número mínimo de dígitos decimais. */
    public static minDecimalDigits(minDigits: number, localeDecimalSymbol: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            if (!control.value) { return null; }

            const value: number = +control.value.toString().replace(localeDecimalSymbol, '.');

            if (Number.isInteger(value)) {
                return { minDecimalDigits: { actual: 0, min: minDigits } };
            }

            if (value && !isNaN(value)) {
                const actualDecimalDigits: number = value.toString().split('.')[1].length;

                if (actualDecimalDigits < minDigits) {
                    return { minDecimalDigits: { actual: actualDecimalDigits, min: minDigits } };
                }
            }

            return null;
        };
    }
}
